import { useContext, useState, useEffect } from "react";
import { useNavigate, Link, useParams, useLocation } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import email from "../../../../Assets/images/profile-managment/email.png"
import call from "../../../../Assets/images/profile-managment/call.svg"
import role from "../../../../Assets/images/profile-managment/role.svg"
import status from "../../../../Assets/images/profile-managment/status.svg"
import Rest from '../../../../Services/Rest';
import { GlobalInfo } from "../../../../Contexts/GlobalContext";
import Toaster from "../../../../Components/Toaster";
import Loader from "../../../../Components/Loader";
import { RequestorService } from "../../../../Services/Requestor.Service";
import TokenService from "../../../../Services/Token.service";
import { Dropdown, Form as RBForm } from "react-bootstrap";
import { AdminService } from "../../../../Services/Admin.service";
import ConfirmationModal from "../../../../Components/ConfirmationModal";
import UserProfileDetails from "../../../../Components/AdministrativeSettings/UserProfileDetails";
import TrainingStatusModal from "../../../../Components/AdministrativeSettings/RequestorManagement/TrainingStatusModal";
import LabsMultiselectDropdown from "../../../../Components/AdministrativeSettings/LabsMultiselectDropdown";
import { getErrorMessage } from "../../../../Utils/Common";



function RequestorProfile() {
  
const checkIfExists = (column, value) => { 
   
   if(value!==requestorData.email){ 
       return Rest.post(`/user/exists`, { column, value })
           .then(response => response.data.exists)
           .catch(error => {
               console.error('Error checking if exists:', error);
               return false;
           });
   }
   return Promise.resolve(false);
};
// Validation schema using Yup
const validationSchema = Yup.object().shape({
    first_name: Yup.string().required('First Name is required'),
    middle_name: Yup.string().required('Middle Name is required'),
    last_name: Yup.string().required('Last Name is required'),
    email: Yup.string()
        .email('Invalid email format')
        // .matches(/^[^@\s]+@[^@\s]+\.[^@\s]+$/, 'Invalid email address')
        .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Invalid email format')
        .required('Email is required')
        // .test('email-unique', 'Email already exists', function (value) {
        //     if (!value) return true;
        //     return checkIfExists('email', value).then((exists) => {
        //         return !exists;
        //     });

        // })
        ,
    phone_number: Yup.string()
        .matches(/^[0-9]{10}$/, 'Phone Number must be 10 digits')
        .required('Phone Number is required'),
    pharma_id: Yup.string().required('Pharma is required'),
    campus_id: Yup.string().required('Campus is required'),
    // gender: Yup.string().required('Gender is required'),
    // lab_id: Yup.string().required('Lab selection is required'),
    lab_id: Yup.array()
    .min(1, "Please select at least one lab") // require at least one lab
    .required("Lab is required"),
});

const normalizeListResponse = (response) => {
    const data = response?.data || response || {};
    if (Array.isArray(data)) {
        return data;
    }
    if (Array.isArray(data.list)) {
        return data.list;
    }
    if (Array.isArray(data.data)) {
        return data.data;
    }
    return [];
};

const formatRequestorData = (data = {}) => ({
    ...data,
    pharma_id: data?.pharma_id ? String(data.pharma_id) : "",
    campus_id: data?.campus_id ? String(data.campus_id) : "",
    lab_id: Array.isArray(data?.lab_id) ? data.lab_id : (Array.isArray(data?.labs) ? data.labs.map((lab) => lab.id) : []),
});
 
    // const { id } = useParams();
    const navigate = useNavigate();
    const { appUserIsLogin, isSidebarVisible } = useContext(GlobalInfo);

    const [labOptions, setLabOptions] = useState([]);
    const [pharmaOptions, setPharmaOptions] = useState([]);
    const [campusOptions, setCampusOptions] = useState([]);
    const [pharmaSearch, setPharmaSearch] = useState("");
    const [campusSearch, setCampusSearch] = useState("");
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');
    const [loading, setLoading] = useState(false);
    const previousUrl = TokenService.getPrevLink();
    // const [requestorData, setRequestorData] = useState(null);
    const location = useLocation();
    const initialRequestorState = formatRequestorData(location.state?.requestor || {});
    const [requestorData, setRequestorData] = useState(initialRequestorState);

    const [navigateToRequestor, setNavigateToRequestor] = useState(false);

    const [showDeactivateModal, setShowDeactivateModal] = useState(false);

    const handleShowDeactivateModal = () => setShowDeactivateModal(true);
    const handleCloseDeactivateModal = () => setShowDeactivateModal(false);

    const confirmDeactivateUser = () => {
        handleChangeStatus(requestorData, requestorData.active);
        handleCloseDeactivateModal();
    };


    const [showDeleteModal, setShowDeleteModal] = useState(false);
    
    const handleShowDeleteModal = () => setShowDeleteModal(true);
    const handleCloseDeleteModal = () => setShowDeleteModal(false);

    const confirmDeleteUser = () => {
        handleDeleteRequestor(requestorData.id);
        handleCloseDeleteModal();
    };


     const [showTrainingModal, setShowTrainingModal] = useState(false);
        const [trainingCompleted, setTrainingCompleted] = useState(requestorData.training_completed);
        const [trainingDate, setTrainingDate] = useState(requestorData.training_completed_date ? new Date(requestorData.training_completed_date) : null);
    
        const handleShowTrainingModal = () => setShowTrainingModal(true);
        const handleCloseTrainingModal = () => setShowTrainingModal(false);
    
        const handleSaveTrainingStatus = () => {

            setToastMessage("Training Status Updated.");
            setToastVariant('success');
            setShowToast(true);

            handleCloseTrainingModal();
        };


    useEffect(() => {
        
        RequestorService.getRequestorDetails(requestorData.id)
            .then(response => {

                const data = response.data.user;
               
                const formatted = formatRequestorData({
                    id: data.id,
                    display_name: data.display_name,
                    first_name: data.first_name,
                    middle_name: data.middle_name,
                    last_name: data.last_name,
                    username: data.username || '',
                    email: data.email || '',
                    phone_number: data.phone_number,
                    // gender: data.gender,
                    sequence: data.sequence,
                    lab_id: Array.isArray(data.labs) 
                        ? data.labs.map(lab => lab.id) 
                        : [],
                    pharma_id: data.pharma_id,
                    campus_id: data.campus_id,
                    active: data.active,
                    role_name: "Requestor"
                    // password: '',  
                    // confirm_password: ''
                });
                
                setRequestorData(formatted);
              
            })
            .catch(error => {
                console.log("Error fetching requestor details:", error);
            });
    }, [requestorData?.id]);
 
    const handleSubmit = async (values, { resetForm, setSubmitting, setFieldError }) => {
        if (!requestorData.id) {
            setToastMessage("Requestor ID is missing.");
            setToastVariant('error');
            setShowToast(true);
            return;
        }
        const emailExists = await checkIfExists('email', values.email);
        if (emailExists) {
            setFieldError('email', 'Email already exists');
            setSubmitting(false);
            return;
        }

        setLoading(true);
        const requestorDataSubmit = {
            user_id: requestorData.id,
            first_name: values.first_name,
            middle_name: values.middle_name,
            last_name: values.last_name,
            username: values.username,
            email: values.email,
            password: values.password,
            phone_number: values.phone_number,
            pharma_id: Number(values.pharma_id),
            campus_id: Number(values.campus_id),
            // gender: values.gender,
            sequence: 1,
            is_superadmin: 0,
            user_type: [2],
            lab_id: values.lab_id,

        };

        try {
            const data = await RequestorService.updateRequestor(requestorDataSubmit);
             const message = getErrorMessage(data);
            if (!data.success) {
                setToastMessage(message);
                setToastVariant('error');
            } else {
                // resetForm();
                setToastMessage(data.message);
                setToastVariant('success');

                setNavigateToRequestor(true);
            }
        } catch (error) {
            setToastMessage('Failed to update requestor.');
            setToastVariant('error');
        } finally {
            setLoading(false);
            setShowToast(true);
        }
    };

    useEffect(() => {
        const fetchLabs = async () => {
            try {
                const response = await RequestorService.getLabList();
                setLabOptions(response.labs || []);
            } catch (error) {
                console.error("Error fetching labs", error);
            }
        };
        fetchLabs();
    }, []);

    useEffect(() => {
        const fetchPharmaList = async () => {
            try {
                const payload = { limit: 1000, offset: 0, filters: [{ status: [1] }] };
                const response = await RequestorService.getPharmaList(payload);
                setPharmaOptions(normalizeListResponse(response));
            } catch (error) {
                console.error("Error fetching pharma list", error);
                setPharmaOptions([]);
            }
        };

        const fetchCampusList = async () => {
            try {
                const payload = { limit: 1000, offset: 0, filters: [{ status: [1] }] };
                const response = await RequestorService.getCampusList(payload);
                setCampusOptions(normalizeListResponse(response));
            } catch (error) {
                console.error("Error fetching campus list", error);
                setCampusOptions([]);
            }
        };

        fetchPharmaList();
        fetchCampusList();
    }, []);


    useEffect(() => {
        if (navigateToRequestor) {
            const timer = setTimeout(() => {
                // administrative-settings
                navigate('/admin/pharma-management');
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [navigateToRequestor]);
    if (!requestorData) {
        return <Loader loading={true} />;
    }
    const handleChangeStatus = async (requestor, status) => {
        setLoading(true);
        const newStatus = requestorData.active ? 0 : 1;
        try {
            
            const response = await AdminService.changeUserStatus(requestorData.id, newStatus);

            if (response.success == true) {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('success');
                const userDetails = await AdminService.getUserDetails(requestorData.id);
                
                setRequestorData(formatRequestorData(userDetails.user));
                setLoading(false);

            }
            else {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('error');
                setLoading(false);

            }
        } catch (error) {
            setToastMessage("Failed to change user status");
            setShowToast(true);
            setToastVariant('error');
            console.error("Failed to change user status:", error);
            setLoading(false);

        }
    };
 
    const handleDeleteRequestor = async (userId) => {
        setLoading(true);
        try {
            const payload = {
                // admin_id : TokenService.getUserId(),
                requestor_id : userId,
            }
            const response = await AdminService.deleteRequestorUser(payload);

            if (response.success == true) {
                setLoading(false);
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('success');
                console.log("Requestor deleted successfully:", response);
                // fetchRequestorList();
                setNavigateToRequestor(true);
            }
            else {
                setLoading(false);
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('error');

            }
        } catch (error) {
            setLoading(false); 
            setToastMessage(error.response.data.message);
            setShowToast(true);
            setToastVariant('error');
            console.error("Failed to delete user:", error.response.data.message);
        }
    };
    return (
        <>
            <Loader loading={loading} />
            <div className={`${!isSidebarVisible ? 'collapsed-body' : ''}`}>
                <div className="el-middle-wrapper">
                    <h2 className="el-title">Requestor Profile</h2>
                    <Link className="back-link" to={`${previousUrl}`}><i className='el-icon-back'></i> Requestor Management</Link>
                    <UserProfileDetails userType="requestor" userData={requestorData} handleShowDeleteModal={handleShowDeleteModal} handleShowTrainingModal={handleShowTrainingModal} handleChangeStatus={handleShowDeactivateModal} />
                    {/* <div className="el-profile-board el-bg-table mb-5">
                        <div className="el-card-content">
                            <div className="d-sm-flex align-items-md-center"> 
                                <div className="el-property-details-card-content ">
                                    <div className="el-flexbox">
                                        <div>
                                            <h3>{requestorData.display_name}</h3>
                                        </div>
                                        <Dropdown>
                                            <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                                                Action
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu className="el-admin">

                                              
                                                <Dropdown.Item onClick={handleShowDeactivateModal}>
                                                    <label className={requestorData.active ? `text-danger` : `text-success`}> {requestorData.active ? 'Deactivate' : 'Activate'}</label>
                                                </Dropdown.Item>
 
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12 mx-fit-content">
                                            <div className="flex-sec">
                                                <div className="el-flex-area  mb-3 mb-lg-0">
                                                    <div className="location-icon">
                                                        <img src={email} alt="" className="me-3" />
                                                    </div>
                                                    <div className="el-content-detail">
                                                        <p className="el-request-detail-profile-title">
                                                            Email Address
                                                        </p>
                                                        <h4 className="el-request-detail-profile-name">
                                                            {requestorData.email}
                                                        </h4>
                                                    </div>
                                                </div>
                                                <div className="el-flex-area  mb-3 mb-lg-0">
                                                    <div className="location-icon">
                                                        <img src={call} alt="" className="me-3" />
                                                    </div>
                                                    <div className="el-content-detail">
                                                        <p className="el-request-detail-profile-title">
                                                            Phone Number
                                                        </p>
                                                        <h4 className="el-request-detail-profile-name">
                                                            {requestorData.phone_number}
                                                        </h4>
                                                    </div>
                                                </div>
                                                <div className="el-flex-area mb-3 mb-lg-0 ">
                                                    <div className="location-icon ">
                                                        <img src={role} alt=" " className="me-3 " />
                                                    </div>
                                                    <div className="el-content-detail ">
                                                        <p className="el-request-detail-profile-title ">
                                                            Role
                                                        </p>
                                                        <h4 className="el-request-detail-profile-name ">
                                                            {requestorData.role_name}
                                                        </h4>
                                                    </div>
                                                </div>
                                                <div className="el-flex-area mb-3 mb-lg-0 ">
                                                    <div className="location-icon ">
                                                        <img src={status} alt=" " className="me-3 " />
                                                    </div>
                                                    <div className="el-content-detail ">
                                                        <p className="el-request-detail-profile-title ">
                                                            Status
                                                        </p>
                                                        <h4 className={`el-request-detail-profile-name ${requestorData.active ? 'active' : ''} `}>
                                                            {requestorData.active ? 'Active' : 'Inactive'}
                                                        </h4>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div> */}

                    <div className="el-bg-table el-super-admin mt-5">
                        <Formik
                            initialValues={requestorData}
                            validationSchema={validationSchema}
                            onSubmit={handleSubmit}
                            enableReinitialize={true} // Enable reinitialization when initialValues change
                        >
                            {({ errors, touched, values, setFieldValue, setFieldTouched }) => {
                                const filteredPharmaOptions = pharmaOptions.filter((pharma) =>
                                    (pharma?.pharma_name || "")
                                        .toLowerCase()
                                        .includes(pharmaSearch.toLowerCase())
                                );

                                const campusOptionsForPharma = campusOptions.filter((campus) => {
                                    if (!values.pharma_id) {
                                        return true;
                                    }
                                    const campusPharmaMatches = String(campus.pharma_id) === String(values.pharma_id);
                                    const campusIsSelected =
                                        String(campus.id || campus.campus_id) === String(values.campus_id);
                                    return campusPharmaMatches || campusIsSelected;
                                });

                                const filteredCampusOptions = campusOptionsForPharma.filter((campus) =>
                                    (campus?.campus_name || "")
                                        .toLowerCase()
                                        .includes(campusSearch.toLowerCase())
                                );

                                const selectedPharma = pharmaOptions.find(
                                    (pharma) => String(pharma.id) === String(values.pharma_id)
                                );
                                const selectedCampus = campusOptions.find(
                                    (campus) =>
                                        String(campus.id || campus.campus_id) === String(values.campus_id)
                                );
                                const campusDropdownDisabled = !values.pharma_id;

                                return (
                                <Form>
                                    <div className="row mt-3 mt-md-0 col-xl-12">
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Select Pharma <span className="text-red">*</span></label>
                                            <Dropdown className="w-100">
                                                <Dropdown.Toggle
                                                    variant="light"
                                                    className={`w-100 text-start form-control ${touched.pharma_id && errors.pharma_id ? "is-invalid" : ""}`}
                                                >
                                                    {selectedPharma?.pharma_name || "Select Pharma"}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu className="w-100" style={{ maxHeight: "250px", overflowY: "auto" }}>
                                                    <div className="px-2 py-2">
                                                        <RBForm.Control
                                                            type="text"
                                                            placeholder="Search pharma..."
                                                            value={pharmaSearch}
                                                            onChange={(e) => setPharmaSearch(e.target.value)}
                                                        />
                                                    </div>
                                                    <Dropdown.Divider />
                                                    {filteredPharmaOptions.length > 0 ? (
                                                        filteredPharmaOptions.map((pharma) => (
                                                            <Dropdown.Item
                                                                key={pharma.id}
                                                                onClick={() => {
                                                                    setFieldValue("pharma_id", String(pharma.id));
                                                                    setFieldTouched("pharma_id", true, false);
                                                                    setFieldValue("campus_id", "");
                                                                    setFieldTouched("campus_id", false, false);
                                                                    setCampusSearch("");
                                                                }}
                                                            >
                                                                {pharma.pharma_name}
                                                            </Dropdown.Item>
                                                        ))
                                                    ) : (
                                                        <p className="px-3 text-muted mb-0">No pharma found</p>
                                                    )}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                            {touched.pharma_id && errors.pharma_id && (
                                                <div className="invalid-feedback d-block">{errors.pharma_id}</div>
                                            )}
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Select Campus <span className="text-red">*</span></label>
                                            <Dropdown className="w-100">
                                                <Dropdown.Toggle
                                                    variant="light"
                                                    disabled={campusDropdownDisabled}
                                                    className={`w-100 text-start form-control ${touched.campus_id && errors.campus_id ? "is-invalid" : ""}`}
                                                >
                                                    {selectedCampus?.campus_name ||
                                                        (campusDropdownDisabled ? "Select pharma first" : "Select Campus")}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu className="w-100" style={{ maxHeight: "250px", overflowY: "auto" }}>
                                                    <div className="px-2 py-2">
                                                        <RBForm.Control
                                                            type="text"
                                                            placeholder="Search campus..."
                                                            value={campusSearch}
                                                            onChange={(e) => setCampusSearch(e.target.value)}
                                                            disabled={campusDropdownDisabled}
                                                        />
                                                    </div>
                                                    <Dropdown.Divider />
                                                    {campusDropdownDisabled ? (
                                                        <p className="px-3 text-muted mb-0">Select pharma first</p>
                                                    ) : filteredCampusOptions.length > 0 ? (
                                                        filteredCampusOptions.map((campus) => {
                                                            const campusId = campus.id || campus.campus_id;
                                                            return (
                                                                <Dropdown.Item
                                                                    key={campusId}
                                                                    onClick={() => {
                                                                        setFieldValue("campus_id", String(campusId));
                                                                        setFieldTouched("campus_id", true, false);
                                                                    }}
                                                                >
                                                                    {campus.campus_name}
                                                                </Dropdown.Item>
                                                            );
                                                        })
                                                    ) : (
                                                        <p className="px-3 text-muted mb-0">No campus found</p>
                                                    )}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                            {touched.campus_id && errors.campus_id && (
                                                <div className="invalid-feedback d-block">{errors.campus_id}</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="row mt-3 mt-md-0 col-xl-12">
                                        <div className="jb-filters el-board-table col-md-4"> 
                                            <div className="job-list-st-filter el-request-management-dropdown">
                                            <LabsMultiselectDropdown
                                                samples={labOptions}
                                                values={values}
                                                setFieldValue={setFieldValue}
                                                errors={errors}
                                                touched={touched}
                                            />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row  col-xl-12">
                                        {/* 'username', 'email', 'password', 'confirm_password', */}
                                        {['first_name', 'middle_name', 'last_name', 'email', 'phone_number'].map(field => (
                                            <div className="col-md-4" key={field}>
                                                <label htmlFor={field} className="form-label">
                                                    {field.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())}<span className="text-red">*</span>
                                                </label>
                                                <Field
                                                    // type={field.includes('password') ? 'password' : 'text'}
                                                    type={field.includes('password') ? 'password' : field === 'phone_number' ? 'number' : 'text'}
                                                    maxLength={field === 'phone_number' ? 10 : undefined}
                                                    onInput={(e) => {
                                                        if (field === 'phone_number' && e.target.value.length > 10) {
                                                            e.target.value = e.target.value.slice(0, 10);
                                                        }
                                                        else if (field == 'email') {
                                                            e.target.value = e.target.value.replace(/\s/g, '').slice(0, 50);
                                                        }
                                                        else {
                                                            // e.target.value = e.target.value.replace(/[^a-zA-Z0-9 ]/g, '').slice(0, 50);
                                                            e.target.value = e.target.value.replace(/\s/g, '').replace(/[^a-zA-Z0-9]/g, '').slice(0, 50);
                                                        }
                                                    }}
                                                    name={field}
                                                    className={`form-control ${field === 'phone_number' ? 'no-arrows' : ''}`}

                                                    placeholder={`Enter ${field
                                                        .replace(/_/g, ' ')
                                                        .trim()
                                                        .replace(/\b\w/g, (char) => char.toUpperCase())}`}
                                                />
                                                <ErrorMessage name={field} component="div" className="text-danger" />
                                            </div>
                                        ))}

                                        {/* Gender Radio Buttons */}
                                        {/* <div className="col-md-4">
                                            <label className="form-label">Biological Sex<span className="text-red">*</span></label>
                                            <div className="d-flex justify-content-between w-40 mt-1 mt-3  ms-3">
                                                {['XY', 'XX'].map((gender) => (
                                                    <div className="form-check " key={gender}>
                                                        <Field id={`biological_sex_${gender}`} type="radio" name="gender" value={gender} className="form-check-input radio-pointer" />
                                                        <label htmlFor={`biological_sex_${gender}`} className="form-check-label radio-pointer">&nbsp; {gender}</label>
                                                    </div>
                                                ))}
                                            </div>
                                            <ErrorMessage name="gender" component="div" className="text-danger" />
                                        </div> */}

                                        {/* Lab Dropdown */}
                                        {/* <div className="col-md-4">
                                            <label htmlFor="lab_id" className="form-label">Select Lab</label><span className="text-red">*</span>
                                            <Field as="select" name="lab_id" className="form-control">
                                                <option value="">Select a Lab</option>
                                                {labOptions.map((lab) => (
                                                    <option key={lab.id} value={String(lab.id)}>{lab.name}</option>
                                                ))}
                                            </Field>
                                            <ErrorMessage name="lab_id" component="div" className="text-danger" />
                                        </div> */}
                                    </div>
                                    <div className="d-flex align-items-center mt-3">
                                    <button type="submit" className="el-main-button me-3"><span>Submit</span></button>
                                    {/* administrative-settings */}
                                    <Link className="back-link ms-3" to="/admin/pharma-management">Close</Link></div>

                                                          {/*               <div>
                                        <h3>Values</h3>
                                        <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                            {JSON.stringify(values, null, 2)}
                                        </pre>
                                        <h3>Errors</h3>
                                        <p>Total Errors: {Object.keys(errors).length}</p>
                                        <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                            {JSON.stringify(errors, null, 2)}
                                        </pre>       
                                    </div> */}
                                </Form>
                                );
                            }}
                        </Formik>
                    </div>
                    {/* Deactivate Confirmation Modal */}
                    <ConfirmationModal
                        show={showDeactivateModal}
                        onHide={handleCloseDeactivateModal}
                        onConfirm={confirmDeactivateUser}
                        title=""
                        body={`Are you sure you want to ${requestorData.active ? 'deactivate' : 'activate'} user?`}
                        type='deactivateactivate'
                    />
                <ConfirmationModal
                                show={showDeleteModal}
                                onHide={handleCloseDeleteModal}
                                onConfirm={confirmDeleteUser}
                                title=""
                                body={`Are you sure you want to delete user?`}
                                type='delete'
                            />
                    <TrainingStatusModal
                        show={showTrainingModal}
                        handleClose={handleCloseTrainingModal}
                        handleSaveTrainingStatus={handleSaveTrainingStatus}
                        requestor={requestorData}
                        // fetchRequestorList={fetchRequestorList}
                    />
                    <Toaster
                        show={showToast}
                        message={toastMessage}
                        variant={toastVariant}
                        onClose={() => setShowToast(false)}
                    />
                </div>
            </div>
        </>
    );
}

export default RequestorProfile;
